import { render, staticRenderFns } from "./resultCollaborationLogout.vue?vue&type=template&id=9c7048cc&"
import script from "./resultCollaborationLogout.vue?vue&type=script&lang=js&"
export * from "./resultCollaborationLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports